<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { McoStay } from '@/store/modules/stay/mco/types'

const { t } = useI18n()

const props = defineProps<{
  stay: McoStay
}>()

const facilityName = computed(
  () => props.stay.geographicEntity?.shortDescription
    ?? props.stay.legalEntity?.shortDescription
    ?? null,
)
const weekTxt = computed(() => `${String(props.stay.stayEnd.isoWeek()).padStart(2, '0')}/${props.stay.stayEnd.isoWeekYear()}`)
</script>

<template>
  <div class="d-flex flex-column gap-2">
    <span class="ms-0 text-muted small">
      {{ t('stayDisplayer.stay') }}
    </span>
    <span class="ms-0 fw-bold text-nowrap">
      {{ stay.stayStart.format('DD MMM YYYY') }} - {{ stay.stayEnd.format('DD MMM YYYY') }}
      ({{ stay.stayDuration }}{{ t('stayDisplayer.dayShort') }})
    </span>
    <span class="ms-0 text-nowrap">
      {{ t('stayDisplayer.weekShort') }} {{ weekTxt }}
    </span>
    <span
      v-if="stay.raac === 1"
      class="ms-0"
    >
      {{ t('stayDisplayer.generalStayData.raac') }} : {{ t('stayDisplayer.generalStayData.yes') }}
    </span>
    <span
      v-if="facilityName"
      class="ms-0"
    >
      {{ facilityName }}
    </span>
  </div>
</template>
